import axios from "axios";
import { AppDispatch } from "../store";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import {
  setArticleDiscount,
  setArticleDiscountList,
  setIsWaitingArticleDiscountGetResponse,
  setIsWaitingArticleDiscountPostResponse,
  setIsWaitingArticleDiscountPutResponse,
} from "../slices/articleDiscountSlice";
import { getApiUrl } from "../helpers/environmentHelper";
import { ArticleDiscount } from "../../models/responses/articleDiscount";
import { acquireApiToken } from "../helpers/apiTokenHelper";

export const getArticleDiscounts =
  (instance: IPublicClientApplication, account: AccountInfo | null) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleDiscountGetResponse(true));
    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          if (response) {
            const getData: ArticleDiscount[] = (
              await axios.get(`${baseUrl}/article-discount`, {
                timeout: 10000,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${response.accessToken}`,
                },
              })
            ).data;
            dispatch(
              setArticleDiscountList({ articleDiscounts: getData }),
            );
            dispatch(setIsWaitingArticleDiscountGetResponse(false));
          }
        });
      }
    } catch (error) {
      dispatch(setIsWaitingArticleDiscountGetResponse(false));
      console.log(error);
    }
  };

export const getArticleDiscountById =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    id: string | undefined,
  ) =>
  async (dispatch: AppDispatch) => {
    if (!id) return;
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleDiscountGetResponse(true));

    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          if (response) {
            const getData: ArticleDiscount = (
              await axios.get(`${baseUrl}/article-discount/${id}`, {
                timeout: 10000,
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${response.accessToken}`,
                },
              })
            ).data;
            dispatch(
              setArticleDiscount({ articleDiscount: getData }),
            );
            dispatch(setIsWaitingArticleDiscountGetResponse(false));
          }
        });
      }
    } catch (error) {
      dispatch(setIsWaitingArticleDiscountGetResponse(false));
      console.log(error);
    }
  };

export const postArticleDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleDiscount: ArticleDiscount,
    onSuccess: (articleDiscountId: string | null) => void,
  ) =>
  async (dispatch: AppDispatch) => {
    dispatch(setIsWaitingArticleDiscountPostResponse(true));
    const baseUrl = getApiUrl(window.location.hostname, 2);
    let responseId: string | null = null;

    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          try {
            if (response) {
              const apiArticleDiscount = {
                ...articleDiscount,
              };
              const responseData = await axios.post(
                `${baseUrl}/article-discount`,
                apiArticleDiscount,
                {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                },
              );

              if (responseData.status === 201) {
                let locationArray = responseData.headers["location"].split("/");
                responseId = locationArray[locationArray.length - 1];
              }
            }
          } finally {
            onSuccess(responseId);
            dispatch(setIsWaitingArticleDiscountPostResponse(false));
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

export const putArticleDiscount =
  (
    instance: IPublicClientApplication,
    account: AccountInfo | null,
    articleDiscount: ArticleDiscount,
    onSuccess: (articleDiscountId: string | null) => void,
  ) =>
  async (dispatch: AppDispatch) => {
    const baseUrl = getApiUrl(window.location.hostname, 2);
    dispatch(setIsWaitingArticleDiscountPutResponse(true));
    try {
      if (account) {
        acquireApiToken(instance, account).then(async (response) => {
          try {
            if (response) {
              const apiArticleDiscount = {
                ...articleDiscount,
              };
              const responseData = await axios.put(
                `${baseUrl}/article-discount/${articleDiscount.id}`,
                apiArticleDiscount,
                {
                  timeout: 10000,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${response.accessToken}`,
                  },
                },
              );
              if (responseData.status === 204) {
                onSuccess(articleDiscount.id);
              }
            }
          } finally {
            onSuccess(articleDiscount.id);
            dispatch(setIsWaitingArticleDiscountPutResponse(false));
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
